import React from 'react';
import { FormControl } from '@material-ui/core';
import style from "./styles";

const formControl = props => {
    const styles = style();
    return (
        <FormControl variant={props.variant} className={styles[props.styleName]}>
            {
                props.children
            }
        </FormControl>
    );
}

export default formControl